module.exports = __webpack_public_path__ + "static/media/dollar-sign.d36cfa90.svg";